var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "div",
    { staticClass: "font-bold text-sm leading-none mt-1 text-red" },
    [_vm._v("Temporarily Closed")]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b45c052", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/kristinberlehner/sites/mardens/wp-content/themes/mardens/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b45c052","hasScoped":false,"optionsId":"0","buble":{"transforms":{"stripWithFunctional":true}}}!/Users/kristinberlehner/sites/mardens/wp-content/themes/mardens/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/ClosedMessage.vue
// module id = 408
// module chunks = 0